// ─── Aishcraft Product Categories (from website) ─────────────────────────────
// ─── Aishcraft Product Categories (from website) ─────────────────────────────
export const CATEGORIES = [
  // Planners
  { id: "daily-planner",         label: "Daily Planner",          group: "Diaries",  path: "/dailyplanner" },
  { id: "productivity-planner",  label: "Productivity Planner",   group: "Planners",  path: "/productivityplanner" },
  { id: "travel-planner",        label: "Travel Planner",         group: "Table Calendar",  path: "/travel-planner" },
  // { id: "bridal-planner",        label: "Bridal Planner",         group: "Planners",  path: "/bridal-planner" },
  // { id: "weekly-desk-planner",   label: "Weekly Desk Planner",    group: "Planners",  path: "/weekly-desk-planner" },
 
  // { id: "2026-planner",          label: "2026 Planner (Dated)",   group: "Planners",  path: "/twplanner" },
  // Journals
  { id: "gratitude-journal",     label: "Gratitude Journal",      group: "Journals",  path: "/gratitude-journals" },
  // { id: "wellness-journal",      label: "Wellness Journal",       group: "Journals",  path: "/wellness-journals" },
  // { id: "bullet-journal",        label: "Bullet Journal",         group: "Journals",  path: "/bullet-journals" },
  // { id: "recipe-journal",        label: "Recipe Journal",         group: "Journals",  path: "/recipe-journals" },
  // { id: "bridal-journal",        label: "Bridal Journal",         group: "Journals",  path: "/bridal-planner" },
  // Notebooks
  { id: "lined-notebook",        label: "Lined Notebook",         group: "Notebooks", path: "/notebooks" },
  // { id: "plain-notebook",        label: "Plain Notebook",         group: "Notebooks", path: "/notebooks" },
  // { id: "dotted-notebook",       label: "Dotted Notebook",        group: "Notebooks", path: "/notebooks" },
  { id: "bold-bright",      label: "Bold & Bright",        group: "Sketchbook", path: "/bold-bright" },
// { id: "checks-stripes",   label: "Checks & Stripes",     group: "Notebooks", path: "/checks-stripes" },
// { id: "florals-notebook", label: "Florals in Notebooks", group: "Notebooks", path: "/florals" },
// { id: "patterns-prints",  label: "Patterns & Prints",    group: "Notebooks", path: "/patterns-prints" },
  // Photobooks
  { id: "photobook",             label: "Photobook",              group: "Photobooks",path: "/photobook" },
  // Gift Hampers
  { id: "gift-hamper",           label: "Gift Hamper",            group: "Gifts",     path: "/gifts-hamper" },
  // { id: "corporate-gift",        label: "Corporate Gift",         group: "Gifts",     path: "/corporate" },

   { id: "list-notepads",         label: "List Notepads",          group: "Notepads",  path: "/list-notepads" },
];

export const CATEGORY_GROUPS = ["Diaries", "Planners", "Journals", "Notebooks", "Photobooks", "Gifts", "Notepads","Sketchbook","Table Calendar" ];

// ─── Default product template ─────────────────────────────────────────────────
export const EMPTY_PRODUCT = {
  id: "",
  title: "",
  subtitle: "",               // e.g. "Daily Planner"
  categoryId: "daily-planner",
  slug: "",
  description: "",
  longDescription: "",
  price: "",
  salePrice: "",
  sku: "",
  stock: "",
  isPersonalizable: false,
  personalizeLabel: "Personalise It",
  personalizeFont: "",
  personalizeColor: "",
  personalizePosition: "",
  personalizeFontSize: "",
  personalizeRotation: "0",
  images: [],                 // [{url, alt}]
  colors: [],                 // [{name, hex}]
  specs: {                    // product specs
    pages: "",
    size: "",
    cover: "",
    binding: "",
    paper: "",
    weight: "",
  },
  delivery: {
    info: "Ships between 9 Jul and 13 Jul",
    freeAbove: "500",
  },
  seo: {
    title: "",
    description: "",
    keywords: "",
  },
  tags: [],                   // e.g. ["featured", "bestseller", "new-arrival"]
  status: "draft",            // "active" | "draft" | "archived"
  isFeatured: false,
  isBestSeller: false,
  isNewArrival: false,
  isTrending: false,
  isSoldOut: false, 
  createdAt: "",
  updatedAt: "",
};

// ─── Sample products (matching website) ───────────────────────────────────────
export const SAMPLE_PRODUCTS = [
  {
    id: "p1",
    title: "Getting Things Done",
    subtitle: "Daily Planner",
    categoryId: "daily-planner",
    slug: "getting-things-done-2",
    description: "A no-fuss daily layout built for people who run on checklists, time-blocks and finished to-dos.",
    price: "1799",
    salePrice: "1599",
    sku: "AC-DP-001",
    stock: "48",
    isPersonalizable: true,
    images: [],
    colors: [
      { name: "Navy Blue", hex: "#1B2B5E" },
      { name: "Burnt Red", hex: "#8B3A2A" },
      { name: "Forest Green", hex: "#2D5016" },
      { name: "Purple", hex: "#6B3FA0" },
      { name: "Golden Yellow", hex: "#D4A017" },
    ],
    specs: { pages: "365", size: "A5", cover: "Hardcover", binding: "Thread Sewn", paper: "90 GSM", weight: "400g" },
    delivery: { info: "Ships between 9 Jul and 13 Jul", freeAbove: "500" },
    seo: { title: "Getting Things Done Daily Planner | Aishcraft", description: "A no-fuss daily layout built for people who run on checklists.", keywords: "daily planner, productivity, getting things done" },
    tags: ["featured", "bestseller"],
    status: "active",
    isFeatured: true,
    isBestSeller: true,
    isNewArrival: false,
    isTrending: false,
    createdAt: "2025-01-15",
    updatedAt: "2025-07-01",
  },
  {
    id: "p2",
    title: "Midnight Mirage",
    subtitle: "Daily Planner",
    categoryId: "daily-planner",
    slug: "midnight-mirage-4",
    description: "Bold abstract art meets functional planning. For those who live boldly.",
    price: "1799",
    salePrice: "1599",
    sku: "AC-DP-002",
    stock: "32",
    isPersonalizable: true,
    images: [],
    colors: [{ name: "Black", hex: "#1A1A1A" }, { name: "Navy", hex: "#1B2B5E" }],
    specs: { pages: "365", size: "A5", cover: "Hardcover", binding: "Thread Sewn", paper: "90 GSM", weight: "400g" },
    delivery: { info: "Ships between 9 Jul and 13 Jul", freeAbove: "500" },
    seo: { title: "Midnight Mirage Daily Planner | Aishcraft", description: "Bold abstract art meets functional planning.", keywords: "daily planner, midnight mirage, bold" },
    tags: ["trending"],
    status: "active",
    isFeatured: false,
    isBestSeller: false,
    isNewArrival: false,
    isTrending: true,
    createdAt: "2025-02-01",
    updatedAt: "2025-07-01",
  },
  {
    id: "p3",
    title: "Minimal Daily Notepad",
    subtitle: "To-Do Notepad",
    categoryId: "list-notepads",
    slug: "minimal-daily-notepad",
    description: "A clean and minimalist notepad to jot down your everyday priority tasks and grocery lists.",
    price: "499",
    salePrice: "399",
    sku: "AC-NP-001",
    stock: "60",
    isPersonalizable: false,
    images: [],
    colors: [
      { name: "Soft Peach", hex: "#FFE5D9" },
      { name: "Sage Green", hex: "#D8E2DC" }
    ],
    specs: { pages: "50 Sheets", size: "A5", cover: "Cardboard Backing", binding: "Glued Pad", paper: "80 GSM", weight: "150g" },
    delivery: { info: "Ships between 9 Jul and 13 Jul", freeAbove: "500" },
    seo: { title: "Minimal Daily Notepad | Aishcraft", description: "Clean and minimalist notepad for everyday tasks.", keywords: "notepad, to-do list, stationery" },
    tags: ["new-arrival"],
    status: "active",
    isFeatured: false,
    isBestSeller: false,
    isNewArrival: true,
    isTrending: false,
    createdAt: "2025-07-02",
    updatedAt: "2025-07-02",
  },
];

// ─── localStorage helpers ─────────────────────────────────────────────────────
const STORAGE_KEY = "aishcraft_admin_products";

export function getProducts() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (raw) return JSON.parse(raw);
    // First time — seed with samples
    saveProducts(SAMPLE_PRODUCTS);
    return SAMPLE_PRODUCTS;
  } catch {
    return SAMPLE_PRODUCTS;
  }
}

export function saveProducts(products) {
  localStorage.setItem(STORAGE_KEY, JSON.stringify(products));
}

export function addProduct(product) {
  const products = getProducts();
  const newProduct = {
    ...product,
    id: `p${Date.now()}`,
    createdAt: new Date().toISOString().split("T")[0],
    updatedAt: new Date().toISOString().split("T")[0],
  };
  const updated = [...products, newProduct];
  saveProducts(updated);
  return updated;
}

export function updateProduct(id, updates) {
  const products = getProducts();
  const updated = products.map(p =>
    p.id === id ? { ...p, ...updates, updatedAt: new Date().toISOString().split("T")[0] } : p
  );
  saveProducts(updated);
  return updated;
}

export function deleteProduct(id) {
  const products = getProducts();
  const updated = products.filter(p => p.id !== id);
  saveProducts(updated);
  return updated;
}

export function getProductBySlug(slug) {
  return getProducts().find(p => p.slug === slug);
}